/**
 * Utility for managing user's default homepage preference
 * Stores preference in localStorage with profile-specific keys
 */

const PREFERENCE_KEY_PREFIX = 'homepage_preference_';

/**
 * Get the default homepage preference for a user/profile
 * @param {string} userId - User ID or profile ID
 * @returns {string} - 'live', 'english', or 'spanish'
 */
export const getHomepagePreference = (userId) => {
  if (!userId) return 'english'; // Default to English
  
  try {
    const preference = localStorage.getItem(`${PREFERENCE_KEY_PREFIX}${userId}`);
    if (preference && ['live', 'english', 'spanish'].includes(preference)) {
      return preference;
    }
  } catch (error) {
    console.error('Error getting homepage preference:', error);
  }
  
  return 'english'; // Default fallback
};

/**
 * Set the default homepage preference for a user/profile
 * @param {string} userId - User ID or profile ID
 * @param {string} preference - 'live', 'english', or 'spanish'
 */
export const setHomepagePreference = (userId, preference) => {
  if (!userId) return;
  
  if (!['live', 'english', 'spanish'].includes(preference)) {
    console.error('Invalid homepage preference:', preference);
    return;
  }
  
  try {
    localStorage.setItem(`${PREFERENCE_KEY_PREFIX}${userId}`, preference);
  } catch (error) {
    console.error('Error setting homepage preference:', error);
  }
};

/**
 * Get the route path for a homepage preference
 * @param {string} preference - 'live', 'english', or 'spanish'
 * @returns {string} - Route path
 */
export const getHomepageRoute = (preference) => {
  switch (preference) {
    case 'live':
      return '/live-tv';
    case 'spanish':
      return '/espanol';
    case 'english':
    default:
      return '/';
  }
};

